// Client-side period → { from, to } datetime ranges for the unified
// /staff/none/list endpoint (proposal §7.2 / §12.3).
//
// `to` is EXCLUSIVE on the backend ($lt, proposal §14.2), so the ranges below
// are disjoint and contiguous — each boundary belongs to exactly one period,
// which keeps the gallery's accumulated list free of duplicate records.
// (This deviates from the doc's literal now/earlier boundaries, which overlapped.)
//
// Order loaded by LeftPanel: now → earlier → yesterday → week → older (paginated).

function startOfToday () {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  return d
}

function startOfCurrentHour () {
  const d = new Date()
  d.setMinutes(0, 0, 0)
  return d
}

function daysAgoStart (n) {
  const d = new Date()
  d.setDate(d.getDate() - n)
  d.setHours(0, 0, 0, 0)
  return d
}

export const PERIOD_RANGES = {
  // This hour so far.
  now: () => ({ from: startOfCurrentHour().toISOString(), to: new Date().toISOString() }),
  // Earlier today, up to the top of the current hour.
  earlier: () => ({ from: startOfToday().toISOString(), to: startOfCurrentHour().toISOString() }),
  // All of yesterday.
  yesterday: () => ({ from: daysAgoStart(1).toISOString(), to: startOfToday().toISOString() }),
  // 2–7 days ago.
  week: () => ({ from: daysAgoStart(7).toISOString(), to: daysAgoStart(1).toISOString() }),
  // Everything older than 7 days, paginated.
  older: (page = 1) => ({ from: null, to: daysAgoStart(7).toISOString(), page })
}
